<template>
  <div class="admin">
    <el-form ref="form" :model="form" label-width="150px">
      <el-form-item label="类型:">
        <el-select v-model="form.a_type" placeholder="请选择">
          <el-option label="笔记" value="0"></el-option>
          <!-- <el-option label="小说" value="1"></el-option> -->
        </el-select>
      </el-form-item>
      <el-form-item label="作者:">
        <el-input v-model="form.author" style="width:400px;" placeholder="请输入作者"></el-input>
      </el-form-item>
      <el-form-item label="标题:">
        <el-input v-model="form.title" style="width:400px;" placeholder="请输入标题"></el-input>
      </el-form-item>
      <el-form-item label="介绍:">
        <el-input
          type="textarea"
          placeholder="请输入介绍"
          v-model="form.essay"
          maxlength="100"
          show-word-limit>
        </el-input>
      </el-form-item>
      <el-upload
        class="upload-demo"
        style="display: none"
        action="https://www.flikef.com/api/article/uploadImg/"
        :data="{imgName: 'file'}"
        :on-success="handSuccess"
        multiple>
      </el-upload>
      <div class="container">
        <quill-editor ref="myTextEditor" v-model="form.article" :options="editorOption"></quill-editor>
      </div>
      <div style="text-align: center; margin-bottom: 50px">
        <el-button style="width: 300px" type="primary" @click="onSubmit">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
  import 'quill/dist/quill.core.css';
  import 'quill/dist/quill.snow.css';
  import 'quill/dist/quill.bubble.css';
  import { quillEditor } from 'vue-quill-editor';
  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'], // toggled buttons
    ['blockquote', 'code-block'],
    [{ header: 1 }, { header: 2 }], // custom button values
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
    [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
    [{ direction: 'rtl' }], // text direction
    [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    [{ font: [] }],
    [{ align: [] }],
    ['image'],
    ['clean'] // remove formatting button
  ]
  export default {
    name: 'admin',
    metaInfo () {
      return {
        title:'F F 的 Blog'
      }
    },
    data () {
      return {
        form: {
          author: '',
          title: '',
          essay: '',
          a_img: '',
          article: '',
          a_type: ''
        },
        editorOption: {
          placeholder: '',
          theme: 'snow',  // or 'bubble'
          modules: {
            toolbar: {
              container: toolbarOptions,  // 工具栏
              handlers: {
                'image': function (value) {
                  if (value) {
                    document.querySelector('.upload-demo input').click()
                  } else {
                    this.quill.format('image', false)
                  }
                }
              }
            }
          }
        }
      }
    },
    components: {
      quillEditor
    },
    mounted () {
      var userInfo = sessionStorage.getItem('userInfo')
      if(!userInfo) this.$router.replace('/')
    },
    methods: {
      handSuccess (res) {
        let quill = this.$refs.myTextEditor.quill
        let length = quill.getSelection().index
        // 插入图片  res.info为服务器返回的图片地址
        if (res.code == 0) {
          if(!this.form.a_img) this.form.a_img = res.str
          quill.insertEmbed(length, 'image',  this.situationImgUrl + res.str)
            // 调整光标到最后
          quill.setSelection(length + 1)
        } else {
          this.$message.error(res.msg)
        }
      },
      onEditorChange({ editor, html, text }) {
        // console.log(editor)
        // console.log(text)
        this.form.article = html
      },
      onSubmit () {
        let data = this.form
        data.a_time = new Date().getTime()
        data.amount = 1
        data.is_state = 1
        this.$http.post('article/add_article', data, true).then(res => {
          if(res.data.code == 0){
            this.$message.success(res.data.msg)
            this.form = {
              author: '',
              title: '',
              essay: '',
              a_img: '',
              article: '',
              a_type: ''
            }
          } else {
            this.$message.warning(res.data.msg)
          }
        }).catch(err => {
          this.$message.error('网络有误！')
        })
      },

    },
  }
</script>

<style>
  .admin {
    padding: 20px 0;
    box-sizing: border-box;
  }

  .container {
    padding: 20px 40px;
    box-sizing: border-box;
    height: 500px;
    margin-bottom: 30px;
  }

  .quill-editor {
    height: 90%;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin.vue